'use client'

import { useTranslations } from 'next-intl'
import { useRef } from 'react'

import { Card } from '@/entities/auth'
import { useRouter } from '@/shared/i18n'
import { Slot } from '@/shared/lib'
import { useDialog } from '@/shared/lib'
import { AlertDialog } from '@/shared/ui'

import { FindIDForm } from './find-id-form'

const DIALOG = {
  FIND_ID_COMPLETE: 'FIND_ID_COMPLETE',
} as const

type FindIDDialog = keyof typeof DIALOG

export const FindIDPage = () => {
  const router = useRouter()
  const { isOpen, open, close } = useDialog<FindIDDialog>()
  const emailRef = useRef('')

  const t = useTranslations('find_id')

  const closeDialog = (key: FindIDDialog) => () => {
    close(key)
  }

  const handleSuccess = (username: string) => {
    const [name, domain] = username.split('@')
    const maskedName = name.length > 2 ? `${name.slice(0, -2)}**` : name

    emailRef.current = `${maskedName}@${domain}`

    open(DIALOG.FIND_ID_COMPLETE)
  }

  const handleConfirm = () => {
    close(DIALOG.FIND_ID_COMPLETE)

    router.push('/sign-in')
  }

  return (
    <>
      <Card>
        <Slot name="title">{t('title')}</Slot>
        <Slot name="description">{t('description')}</Slot>
        <Slot name="children">
          <FindIDForm onSuccess={handleSuccess} />
        </Slot>
      </Card>
      <AlertDialog
        isOpen={isOpen(DIALOG.FIND_ID_COMPLETE)}
        onOpenChange={closeDialog(DIALOG.FIND_ID_COMPLETE)}
        title={t('dialog.title')}
        content={t('dialog.description', { email: emailRef.current })}
        confirmText={t('dialog.button.confirm')}
        onConfirm={handleConfirm}
        preventOutsideClick
      />
    </>
  )
}
